// const BASE_URL = "http://192.168.21.2:5006/node_api/";
const DEFAULT_KEY = '84173b97-b512-4404-8405-d564f856404d'

//demo
// const BASE_URL="https://craig.admin.iossmlm.com/node_api/";

//live
const BASE_URL="https://admin.peakprofittraders.net/node_api/";


const PAYPAL_CLIENT_ID = ""

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
